import { PaginatedCollection, directusApi } from '@/api';

export interface Category {
    id?: number;
    name?: string;
    parent_id?: number;
    slug?: string;
    image?: any;
    cover:any;
    products: Array<any>;
}

export interface CategoryState {
    activeCategory: Category | null;
    activeCategoryLoading: boolean;

    allCategories: Array<Category>;
    allCategoriesLoading: boolean;
    categoriesPerPage: number;
    categoriesPage: number;
    categoriesTotal: number;
}

const defaultCategory = {
    id: 0,
    name: '',
    parent_id: null,
    slug: '',
    image: null,
    cover:null,
    products: [],
};

const state: CategoryState = {
    activeCategory: {
        id: 0,
        name: '',
        parent_id: null,
        slug: '',
        image: null,
        cover:null,
        products: [],
    },
    activeCategoryLoading: false,

    allCategories: [],
    allCategoriesLoading: false,
    categoriesPerPage: 1,
    categoriesPage: 1,
    categoriesTotal: 1,
};

const mutations = {
    toggleallCategoriesLoading(state: CategoryState, data: boolean) {
        state.allCategoriesLoading = data;
    },
    setAllCategories(state: CategoryState, data: PaginatedCollection) {
        state.allCategories = data.items;
        state.categoriesPerPage = data.perPage;
        state.categoriesPage = data.currentPage;
        state.categoriesTotal = data.totalItems;
        
    },
    toggleActiveCategoryLoading(state: CategoryState, data: boolean) {
        state.activeCategoryLoading = data;
    },
    setActiveCategory(state: CategoryState, data: Category) {
        state.activeCategory = data;
    },
};

const actions = {
    async getAll( { _, commit }: any, {search,page}: any) {
        commit('toggleallCategoriesLoading', true);
        let endpoint = `items/products_categories`;

        await directusApi('GET', endpoint)
            .then(res => {
                commit('setAllCategories', {
                    items: res.data.data,
                    currentPage: page,
                });
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('toggleallCategoriesLoading', false);
            });
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
